<template>
  <div class="form-recipients-page">
    <app-page-header title="Destinatários de Formulários">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus"></b-icon>NOVO
      </button>
    </app-page-header>
    <form-recipients-table></form-recipients-table>
  </div>
</template>

<script>
import FormRecipientsTable from '@/components/Tables/FormRecipientsTable.vue';

export default {
  name: 'form-recipients-page',
  components: {
    FormRecipientsTable,
  },
  methods: {
    create() {
      this.$router.push('/form-recipients/create');
    },
  },
};
</script>

<style lang="sass" scoped></style>
